import { styled, lighten } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  padding: "0px 20px",
  height: "78vh",
  overflow: "auto",
  marginTop: "20px",
});

export const DetailsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
});
